import type { IRepository } from '@skystone/shared';
import { repositoryApi } from '@/services/repository-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const repositoryColumns: ColumnDef<IRepository>[] = buildRawColumns<IRepository>([
  { key: 'id', header: 'ID' },
  { key: 'name', header: 'Name' },
  { key: 'fabricRepositoryId', header: 'Fabric Repository ID' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblDimRepositoryPage() {
  const { data: rows, loading, error } = useApi(() => repositoryApi.getAll({ includeArchived: true }), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - dim_repository" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={repositoryColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('dim_repository')}
      />
    </PageContainer>
  );
}
